import { VerificationForm, VerificationFormData } from './verification-form';
import dayjs from 'dayjs';
import { DATE_FORMAT } from '../../../../constants';
import PdfVerificationSignatureInformation from '../../../shared/pdf-generation/pdf-pages/pdf-verification-signature-page';
import { pdf } from '@react-pdf/renderer';

interface VerificationFormContainerProps {}

export const VerificationFormContainer: React.FC<VerificationFormContainerProps> = () => {

  const handleGeneratePdf = async (formData: VerificationFormData): Promise<File> => {
    console.log('Received form data:', formData);
    const combinedData = {
        applicantId: formData.applicantId || formData.email,
        caseId: formData.caseId,
        entityId: formData.entityId || 'Other',
        dateOfBirth: formData.dateOfBirth,
        applicantName: formData.firstName + " " + formData.lastName,
        nameOnCredential: formData.nameOnDocument,
        submissionDeadline: dayjs().add(6, 'month').format(DATE_FORMAT)
    }
    const pdfBlob = await pdf(<PdfVerificationSignatureInformation data={combinedData} />).toBlob();
    return  new File([pdfBlob], 'verification-form.pdf', { type: 'application/pdf' });
  };
  return (<VerificationForm generatePdf={handleGeneratePdf} />);
};
